var _style, _path, _rect, _path2, _path3, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path5, _path6, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnatera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 35.1",
    style: {
      enableBackground: "new 0 0 200 35.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5B5A5A;}\n\t.st1{fill:#29AEE4;}\n\t.st2{fill:#93C253;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.1,8.5h6.5v2.3c0.9-1.1,1.8-1.8,2.7-2.2c0.9-0.4,2-0.6,3.2-0.6c1.3,0,2.4,0.2,3.3,0.6c0.9,0.4,1.7,1,2.4,1.8 c0.5,0.6,0.9,1.3,1.1,2.1c0.2,0.8,0.3,1.6,0.3,2.6v11.7h-6.5v-9.3c0-0.9-0.1-1.6-0.2-2.2c-0.1-0.6-0.4-1-0.7-1.3 c-0.3-0.3-0.6-0.5-1-0.6c-0.4-0.1-0.7-0.2-1.2-0.2c-1.1,0-1.9,0.3-2.5,1c-0.6,0.7-0.9,1.6-0.9,2.8v9.9h-6.5V8.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 8.5,
    className: "st0",
    width: 6.5,
    height: 18.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.6,15c-0.2-0.9-0.7-1.6-1.3-2.2c-0.7-0.6-1.5-0.8-2.4-0.8c-1,0-1.8,0.3-2.5,0.8c-0.6,0.5-1,1.3-1.2,2.2 H153.6z M145.9,18.8c0,2.8,1.3,4.2,4,4.2c1.4,0,2.5-0.6,3.2-1.7h6.3c-1.3,4.2-4.4,6.3-9.5,6.3c-1.6,0-3-0.2-4.3-0.7 c-1.3-0.5-2.4-1.1-3.3-2c-0.9-0.9-1.6-1.9-2.1-3.1c-0.5-1.2-0.8-2.5-0.8-4c0-1.5,0.2-2.9,0.7-4.2c0.5-1.2,1.2-2.3,2.1-3.1 c0.9-0.9,2-1.5,3.2-2c1.3-0.5,2.7-0.7,4.3-0.7c1.6,0,3,0.2,4.2,0.7c1.2,0.5,2.3,1.1,3.2,2c0.9,0.9,1.5,2,2,3.3 c0.5,1.3,0.7,2.7,0.7,4.3v0.7H145.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163,8.5h6.5v3c0.7-1.1,1.5-1.9,2.6-2.5c1-0.6,2.2-0.9,3.5-0.9h0.6c0.2,0,0.4,0,0.7,0.1v6.2 c-0.9-0.4-1.8-0.6-2.8-0.6c-1.5,0-2.6,0.4-3.4,1.3c-0.8,0.9-1.1,2.2-1.1,3.9v7.9H163V8.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.3,17.7c0,0.6,0.1,1.2,0.3,1.7c0.2,0.5,0.5,1,0.9,1.3s0.8,0.7,1.3,0.9c0.5,0.2,1.1,0.3,1.7,0.3 c0.6,0,1.1-0.1,1.6-0.3c0.5-0.2,1-0.5,1.3-0.9c0.4-0.4,0.7-0.8,0.9-1.3c0.2-0.5,0.3-1,0.3-1.6c0-0.6-0.1-1.1-0.3-1.6 c-0.2-0.5-0.5-1-0.9-1.3c-0.4-0.4-0.8-0.7-1.3-0.9c-0.5-0.2-1.1-0.3-1.6-0.3c-0.6,0-1.2,0.1-1.7,0.3s-1,0.5-1.3,0.9 c-0.4,0.4-0.7,0.8-0.9,1.3S185.3,17.1,185.3,17.7 M193.5,8.5h6.5v18.5h-6.5v-2.1c-1.4,1.8-3.3,2.6-5.7,2.6c-1.3,0-2.6-0.2-3.7-0.7 c-1.1-0.5-2.1-1.2-3-2.1c-0.8-0.9-1.5-1.9-2-3.1c-0.5-1.2-0.7-2.5-0.7-3.9c0-1.3,0.2-2.6,0.7-3.8c0.5-1.2,1.1-2.2,1.9-3.1 c0.8-0.9,1.8-1.6,2.9-2.1c1.1-0.5,2.4-0.8,3.7-0.8c2.3,0,4.2,0.8,5.7,2.4V8.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 13.9,
    transform: "matrix(0.7099 -0.7043 0.7043 0.7099 -10.8819 8.7074)",
    className: "st1",
    width: 7.3,
    height: 7.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.8,
    y: 7.7,
    transform: "matrix(0.7099 -0.7043 0.7043 0.7099 -4.6852 11.317)",
    className: "st2",
    width: 7.3,
    height: 7.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 1.5,
    transform: "matrix(0.7099 -0.7043 0.7043 0.7099 1.5115 13.9266)",
    className: "st1",
    width: 7.3,
    height: 7.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 20.2,
    transform: "matrix(0.7099 -0.7043 0.7043 0.7099 -13.4946 14.9113)",
    className: "st1",
    width: 7.3,
    height: 7.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    transform: "matrix(0.7099 -0.7043 0.7043 0.7099 -7.2977 17.5209)",
    className: "st2",
    width: 7.3,
    height: 7.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 7.8,
    transform: "matrix(0.7099 -0.7043 0.7043 0.7099 -1.101 20.1305)",
    className: "st1",
    width: 7.3,
    height: 7.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 26.3,
    transform: "matrix(0.7099 -0.7043 0.7043 0.7099 -16.0456 20.9689)",
    className: "st2",
    width: 7.3,
    height: 7.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 20.1,
    transform: "matrix(0.7099 -0.7043 0.7043 0.7099 -9.8489 23.5785)",
    className: "st1",
    width: 7.3,
    height: 7.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3,
    y: 13.9,
    transform: "matrix(0.7099 -0.7043 0.7043 0.7099 -3.6522 26.1881)",
    className: "st2",
    width: 7.3,
    height: 7.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77,8.5h6.5v2.3c0.9-1.1,1.8-1.8,2.7-2.2c0.9-0.4,2-0.6,3.2-0.6c1.3,0,2.4,0.2,3.3,0.6c0.9,0.4,1.7,1,2.4,1.8 c0.5,0.6,0.9,1.3,1.1,2.1c0.2,0.8,0.3,1.6,0.3,2.6v11.7H90v-9.3c0-0.9-0.1-1.6-0.2-2.2c-0.1-0.6-0.4-1-0.7-1.3 c-0.3-0.3-0.6-0.5-1-0.6c-0.4-0.1-0.7-0.2-1.2-0.2c-1.1,0-1.9,0.3-2.5,1c-0.6,0.7-0.9,1.6-0.9,2.8v9.9H77V8.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,17.7c0,0.6,0.1,1.2,0.3,1.7c0.2,0.5,0.5,1,0.9,1.3s0.8,0.7,1.3,0.9c0.5,0.2,1.1,0.3,1.7,0.3 c0.6,0,1.1-0.1,1.6-0.3c0.5-0.2,1-0.5,1.3-0.9c0.4-0.4,0.7-0.8,0.9-1.3c0.2-0.5,0.3-1,0.3-1.6c0-0.6-0.1-1.1-0.3-1.6 c-0.2-0.5-0.5-1-0.9-1.3c-0.4-0.4-0.8-0.7-1.3-0.9c-0.5-0.2-1.1-0.3-1.6-0.3c-0.6,0-1.2,0.1-1.7,0.3s-1,0.5-1.3,0.9 c-0.4,0.4-0.7,0.8-0.9,1.3S106.3,17.1,106.3,17.7 M114.5,8.5h6.5v18.5h-6.5v-2.1c-1.4,1.8-3.3,2.6-5.7,2.6c-1.3,0-2.6-0.2-3.7-0.7 c-1.1-0.5-2.1-1.2-3-2.1c-0.8-0.9-1.5-1.9-2-3.1c-0.5-1.2-0.7-2.5-0.7-3.9c0-1.3,0.2-2.6,0.7-3.8c0.5-1.2,1.1-2.2,1.9-3.1 c0.8-0.9,1.8-1.6,2.9-2.1c1.1-0.5,2.4-0.8,3.7-0.8c2.3,0,4.2,0.8,5.7,2.4V8.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "133.7,13.9 133.7,26.9 127.2,26.9 127.2,13.9 125,13.9 125,8.5 127.2,8.5 127.2,2.9 133.7,2.9  133.7,8.5 137.4,8.5 137.4,13.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnatera);
export default __webpack_public_path__ + "static/media/innatera.db7f4492ecce5d35bdd0d80f0c164eeb.svg";
export { ForwardRef as ReactComponent };